<template>
  <span class="stylist-option">
    <input v-model="appointmentStylist" :value="stylist.id" type="radio" :id="stylist.name" class="d-none" :disabled="disabled" />
    <StylistWithRating class="stylist-option--label d-inline-flex flex-column align-center mr-4" :stylist="stylist" :disabled="disabled" :for="stylist.name" tag="label" type="appointment" />
  </span>
</template>

<script>
import StylistWithRating from '@/components/StylistWithRating.vue'

export default {
  props: {
    value: { type: Number },
    stylist: { type: Object, required: true },
    disabled: { type: Boolean, default: false }
  },

  components: {
    StylistWithRating
  },

  computed: {
    appointmentStylist: {
      get() {
        return this.value
      },
      set(stylist) {
        this.$emit('input', stylist)
      }
    }
  },

  watch: {
    disabled(isDisabled) {
      if (isDisabled) this.$emit('input', '')
    }
  }
}
</script>

<style lang="scss" scoped>
.stylist-option--label {
  width: 8rem;
}

/* selection ring */
::v-deep label .stylist-image--wrapper::before {
  position: absolute;
  top: -8px;
  left: -8px;
  right: -8px;
  bottom: -8px;
  border-radius: 999vw;
  content: '';
  border: 3px solid var(--v-primary-darken1);
  transition: opacity 100ms ease-in;
  opacity: 0;
}

.stylist-option > input:checked + label ::v-deep .stylist-image--wrapper::before {
  opacity: 1 !important;
}
</style>
